import { BrandLogo } from '@/shared/components/common/brand-logo'

export function ScreenLoader({ label = 'Проверяем сессию...' }: { label?: string }) {
  return (
    <div
      aria-label={label}
      aria-live="polite"
      className="screen-loader fixed inset-0 z-50 flex flex-col items-center justify-center bg-[var(--app-bg)]"
      role="status"
    >
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_center,var(--color-brand-bg-subtle)_0%,transparent_70%)]"
      />

      <div className="relative flex flex-col items-center gap-6">
        <div className="relative">
          <div
            aria-hidden
            className="screen-loader-ring absolute -inset-3 rounded-full border-2 border-[var(--color-brand)]/30"
          />
          <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[var(--color-brand-bg-subtle)] text-[var(--color-brand)] shadow-sm">
            <BrandLogo className="h-7 w-7" />
          </div>
        </div>

        <div className="flex flex-col items-center gap-2">
          <span className="font-display text-base font-semibold tracking-tight text-[var(--color-text)]">
            ИИ-<span className="font-extrabold">Менеджер</span>
          </span>
          <span className="screen-loader-status text-sm text-[var(--color-text-muted)]">
            {label}
          </span>
        </div>
      </div>
    </div>
  )
}
